/**
 * Packages & Services builder — foundation-defaults explainer.
 * Extracted verbatim from the former AgencyServicesPage monolith
 * (Task 150-A). No behavior change.
 */

export function FoundationDefaultsSection() {
  const items = [
    {
      title: 'تأهيل العميل',
      body: 'مسار إلزامي لكل عميل جديد لجمع معلومات البراند، الجمهور، الأهداف، والسياق قبل بدء التنفيذ.',
    },
    {
      title: 'الاستراتيجية',
      body: 'أساس تشغيل المحتوى والحملات. كل عميل يحتاج استراتيجية حتى يكون اتجاه العمل واضحاً قبل الإنتاج أو الإعلانات.',
    },
    {
      title: 'التقارير الأساسية',
      body: 'طبقة قياس ومتابعة مرافقة لأي خدمة فعّالة. ليست خدمة تباع وحدها، بل نتيجة تشغيلية تظهر حسب ما يملكه العميل.',
    },
  ] as const;

  return (
    <section className="card" style={{ padding: 22 }}>
      <div className="sec-title">
        <h2>أساسيات تلقائية لكل عميل</h2>
        <span className="pill pill-active">ليست خدمات قابلة للبيع</span>
      </div>
      <p className="tiny" style={{ color: 'var(--muted)', marginBottom: 14 }}>
        هذه الأشياء مفعّلة كمبدأ تشغيلي داخل النظام لكل عميل. الباقات بالأسفل تحدد الخدمات التجارية
        التي يدفع عليها العميل، أما هذه فهي مسار العمل الأساسي.
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
          gap: 12,
        }}
      >
        {items.map((item) => (
          <div
            key={item.title}
            style={{
              padding: '14px',
              border: '1px solid var(--line)',
              borderRadius: 'var(--r-md)',
              background: 'var(--cream-2)',
            }}
          >
            <strong style={{ display: 'block', marginBottom: 6 }}>{item.title}</strong>
            <p className="tiny" style={{ color: 'var(--ink-2)', margin: 0 }}>
              {item.body}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
